import { Router } from "@angular/router";
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DecimalPipe } from "@angular/common";
import { ExceededTiers } from "src/app/models/login.model";
import { DialogActions } from "../dialog.model";
import { Subject } from "rxjs";

@Component({
  selector: "app-payment-dialog",
  templateUrl: "./payment-dialog.component.html",
  styleUrls: ["./payment-dialog.component.scss"],  
  providers: [DecimalPipe]
})
export class PaymentDialogComponent implements OnInit,OnDestroy {
  title: string;
  text: string;
  actions: DialogActions[];
  iconUrl: string;
  productRoutes = [
    {
      name: "Shipyard",
      iconUrl: "assets/images/application-icons/shipyard-icon.svg",
    },
    {
      name: "Priceyard",
      iconUrl: "assets/images/application-icons/priceyard-icon.svg",
    },
    {
      name: "Planyard",
      iconUrl: "assets/images/application-icons/planyard-icon-v2.svg",
    },
    {
      name: "Logistic",
      iconUrl: "assets/images/application-icons/planyard-icon-v2.svg",
    },
    {
      name: "Netyard",
      iconUrl: "assets/images/application-icons/analytics-icon.svg",
    }
  ]
  private destroy$ = new Subject<void>();
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<PaymentDialogComponent>,
    private router: Router,
    private number: DecimalPipe
  ) {}

  ngOnInit(): void {
    console.log('this.data',this.data)
    if (this.data.balanceOverdue) {
      this.title = "Payment required";
      this.text = `Our records indicate there is an outstanding balance of $${ this.number.transform(this.data.balanceOverdue)}. Please go to billing to continue.`;
      this.actions = [{ text: "Billing" }];              
    } else {
      const betaExceededTier: ExceededTiers = this.data.exceededTiers.find((tier) => !tier.isBeta) || this.data.exceededTiers[0];
      // Remove this line once backend is live
      //betaExceededTier.productName = "Planyard";
      if (betaExceededTier.isBeta) { 
        this.title = betaExceededTier.productName + " is live!";
        this.text = `Thanks for sticking with us throughout the beta process, please go to billing to select your tier.`;
      } else {
        this.title = "Congratulations!";
        this.text = `You have outgrown your current ${betaExceededTier.productName} tier. Kindly proceed to billing to choose the proper tier.`;
      }
      this.iconUrl = this.productRoutes.find(route => route.name.toLowerCase() === betaExceededTier.productName.toLowerCase()).iconUrl;
      this.actions = [{ text: "Billing" }];
    }
  }

  action(e) {
    if (e === "Billing") {
      this.router.navigate(["/settings/billing"]);
      this.dialogRef.close();
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
